import { useEffect, useState } from "react"
import { Autocomplete, Box, Menu, MenuItem, TextField } from "@mui/material"
import Drawer from "@mui/material/Drawer"
import Typography from "@mui/material/Typography"
import Divider from "@mui/material/Divider"
import CloseIcon from "@mui/icons-material/Close"
import MetricAPI from "../../../../api/metric"
import { getTokenLocal } from "../../../../helper/utils"
import { useDispatch, useSelector } from "react-redux"
import {
  setSelectedBlueprintMetrics,
  setSelectedBlueprintMetricsEmpty,
  setSelectedGroups,
} from "../../../redux/slices/metricSlice"
import { setLoading } from "../../../redux/slices/appSlice"
import { toast } from "react-toastify"
import { MetricBlueprintAssignConfirmation } from "../../Modal"
import {
  ButtonContainer,
  DrawerAssignButton,
  DrawerCancelButton,
  DrawerContainer,
  DrawerHeaderWrapper,
  DrawerMainContainer,
  DrawerMiddle,
  DrawerSearchContainer,
} from "./Atom"
import { useResponseHandle } from "../../../hooks"
import { useNavigate } from "react-router"

const metricAPI = new MetricAPI()

export default function MetricBlueprintAssignDrawer({
  state,
  toggleDrawer,
  closeSidebar,
  fetchAllGroups,
  assignMetricsToGroups,
}: any) {
  const dispatch = useDispatch()

  const [groupList, setGroupList] = useState([{}])

  const token: any = getTokenLocal()

  const selectedMetrics = useSelector((state: any) => {
    return state.metric.selectedBlueprintMetrics
  })

  const selectedGroups = useSelector((state: any) => {
    return state.metric.selectedGroups
  })

  const [open, setOpen] = useState(false)
  const [localCloseKey, setLocalCloseKey] = useState("active")

  const handleOpen = () => {
    if (!selectedGroups?.length) {
      toast.error("Please select a group")
      dispatch(setLoading(false))

      return
    } else if (selectedMetrics.length == 0) {
      toast.error("Please select atleast one metric")
      closeSidebar()
      dispatch(setLoading(false))

      return
    }
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSidebarClose = () => {
    closeSidebar()
    // dispatch(setSelectedBlueprintMetrics({ isChecked: null }))
    // dispatch(setSelectedBlueprintMetricsEmpty())
    // dispatch(setSelectedGroups([]))
  }

  const handleGroupSearch = async () => {
    const result: any = await fetchAllGroups()
    if (result?.group) {
      setGroupList(result?.group)
    }
  }

  const handleGroupSelection = (event: any, dataArr: any) => {
    let localGroupSkArray: any = []
    dataArr?.forEach((value: any) => {
      localGroupSkArray.push(value?.group_sk)
    })
    dispatch(setSelectedGroups(localGroupSkArray))
  }

  const handleAssignMetrics = async () => {
    const result = await assignMetricsToGroups()
    closeSidebar()
    dispatch(setSelectedGroups([]))
    setLocalCloseKey("clear")
  }

  useEffect(() => {
    handleGroupSearch()
  }, [])

  return (
    <>
      <MetricBlueprintAssignConfirmation
        open={open}
        handleClose={handleClose}
        handleAssignMetrics={handleAssignMetrics}
      />

      <Drawer
        anchor={"right"}
        open={state["right"]}
        variant="persistent"
        onClose={() => handleSidebarClose()}
      >
        <DrawerContainer>
          <DrawerHeaderWrapper>
            <Typography fontWeight={700}>Assign Metrics</Typography>
            <CloseIcon
              sx={{ cursor: "pointer" }}
              onClick={() => handleSidebarClose()}
            />
          </DrawerHeaderWrapper>

          <Divider sx={{ margin: "0 -21px" }} />

          <DrawerMainContainer>
            <DrawerSearchContainer>
              <Autocomplete
                key={localCloseKey}
                multiple
                size="small"
                disablePortal
                id="combo-box-demo"
                onChange={(e, value) => {
                  handleGroupSelection(e, value)
                }}
                options={
                  !groupList ? [{ label: "Loading...", id: 0 }] : groupList
                }
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField {...params} label="Search Group" />
                )}
              />
            </DrawerSearchContainer>

            <DrawerMiddle>
              <Typography fontWeight={900}>Selected Metrics</Typography>

              {selectedMetrics.map((metric: any) => (
                <Typography fontSize={14} sx={{ margin: "5px 0" }}>
                  {metric?.metric_name}
                </Typography>
              ))}

              {!selectedMetrics.length ? (
                <Typography
                  fontSize={14}
                  color={"red"}
                  sx={{ margin: "5px 0" }}
                >
                  No metric selected
                </Typography>
              ) : null}
            </DrawerMiddle>

            <ButtonContainer>
              <DrawerCancelButton onClick={() => handleSidebarClose()}>
                <Typography color={"#4A79E7"}>Cancel</Typography>
              </DrawerCancelButton>
              <DrawerAssignButton onClick={() => handleOpen()}>
                <Typography color={"#ffffff"}>Assign</Typography>
              </DrawerAssignButton>
            </ButtonContainer>
          </DrawerMainContainer>
        </DrawerContainer>
      </Drawer>
    </>
  )
}
